import { StudentListing } from '../students/student-listing.model';

export class WardGroupAssignment {
  campusWardGroupAssignmentId: number;
  campusWardGroupId: number;
  approvedAddress: string;
  localStudent: StudentListing;
}
